module.exports = __webpack_public_path__ + "static/assets/02717a3f46968e9931f61d8be2ee9aa4.svg";